import { render, staticRenderFns } from "./IcoPieChart.vue?vue&type=template&id=63a44ce0"
import script from "./IcoPieChart.vue?vue&type=script&lang=js"
export * from "./IcoPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports